import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeadDetailPanelRoutingModule } from './lead-detail-panel-routing.module';
import { LeadDetailPanelComponent } from './lead-detail-panel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconModule } from '@visurel/iconify-angular';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { AudiosModule } from 'src/app/shared/audios/audios.module';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SimpleDynamicComponentModule } from 'src/app/shared/simple-form/simple-dynamic-component.module';
import { UploadPdfModule } from 'src/app/shared/upload-pdf/upload-pdf.module';
import { CalsoftpipeModule } from 'src/app/shared/utils/calsoftpipe/calsoftpipe.module';
import { VideosModule } from 'src/app/shared/videos/videos.module';
import { CommonImagesModule } from '../../common-images/common-images.module';
import { ImagesModule } from '../../gold/images/images.module';
import { GoogleCalendarServiceAccountModule } from '../../google-calendar-service-account/google-calendar-service-account.module';
import { LoaderModule } from '../../loader/loader.module';
import { WhatsappChatModule } from '../../whatsappChatModule/whatsapp-chat/whatsapp-chat.module';
import { ActivityModule } from '../activity/activity.module';
import { DealsModule } from '../deals/deals.module';
import { LeadDetailRoutingModule } from '../lead-detail/lead-detail-routing.module';
import { LeadDetailModule } from '../lead-detail/lead-detail.module';
import { LeadsmeetingModule } from '../../companies/leadsmeeting/leadsmeeting.module';
import { ActivityNewModule } from '../lead-detail/activity-new/activity-new.module';
import { TaskNewModule } from 'src/app/shared/task-new/task-new.module';
import { InboundEmailsModule } from '../inbound-emails/inbound-emails.module';
import { SendAllEmailModule } from '../send-all-email/send-all-email.module';
import { TaskTableModule } from '../../sequence/task-table/task-table.module';

@NgModule({
  declarations: [
    LeadDetailPanelComponent
  ],
  imports: [
    CommonModule,
    LeadDetailPanelRoutingModule,
    MatTooltipModule,
    LeadDetailRoutingModule,
    CustomFlexLayoutModule,
    WhatsappChatModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatTabsModule,
    MatMenuModule,
    CalsoftpipeModule,
    ActivityModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMatSelectSearchModule,
    SimpleDynamicComponentModule,
    CommonImagesModule,
    VideosModule,
    AudiosModule,
    IconModule,
    LoaderModule,
    PerfectScrollbarModule,
    GoogleCalendarServiceAccountModule,
    DealsModule,
    MatButtonToggleModule,
    MatChipsModule,
    ImagesModule,
    UploadPdfModule,
    CommonFileUploadModule,
    PipesModule,
    LeadDetailModule,
    LeadsmeetingModule,
    ActivityNewModule,
    TaskNewModule,
    SendAllEmailModule,
    InboundEmailsModule,
    TaskTableModule

  ],
  exports: [
    LeadDetailPanelComponent
  ]
})
export class LeadDetailPanelModule { }
